// const source = 'podsDataTable'

function uploadMultipodsFile () {

  

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-multipods-file',
      title: 'Multipods File',
      data: [],
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': uploadMultipodsFile,
}
